// Shared by the React pages and scripts/prerender.mjs: content-pack Markdown -> HTML (text unchanged).
import { marked } from 'marked';
import { CONTENT_PACK } from './contentPack.js';

export const VERIFIED_LINE = 'Last verified: 14 October 2026 · Rules change — always confirm with your airline/authority before travel.';
export const CALCULATOR = '/guides/iata-crate-size-calculator';
export const CTA_HREF = '/#check';

export const packName = (p) => (p.kind === 'airlines'
  ? p.h1.split(' Pet Policy')[0]
  : p.h1.match(/ to (?:the )?(.+?):/)[1]);

const PAIRS = {
  'united-states': ['delta', 'american-airlines'],
  'united-kingdom': ['british-airways'],
  australia: ['qantas'],
  singapore: ['singapore-airlines'],
  france: ['air-france'],
  mexico: ['delta', 'american-airlines'],
};
const GUIDES = {
  '/guides/iata-crate-size-calculator': 'IATA crate size calculator',
  '/guides/iata-crate-requirements-2026': 'IATA crate requirements 2026',
  '/guides/metal-bolts-vs-plastic-clips': 'Metal bolts vs plastic clips',
  '/guides/international-pet-travel-documents': 'International pet travel documents',
  '/airlines': 'All airline pet policies',
  '/destinations': 'All destinations',
};
const label = (href) => GUIDES[href] || (CONTENT_PACK[href] ? packName(CONTENT_PACK[href]) : href);

export const relatedLinks = (p) => {
  const links = p.kind === 'airlines'
    ? ['/guides/iata-crate-size-calculator', '/guides/iata-crate-requirements-2026', '/guides/metal-bolts-vs-plastic-clips', '/airlines',
      ...Object.entries(PAIRS).filter(([, a]) => a.includes(p.slug)).map(([d]) => `/destinations/${d}`),
      ...(['klm', 'lufthansa', 'emirates'].includes(p.slug) ? ['/destinations'] : [])]
    : ['/guides/iata-crate-size-calculator', '/guides/international-pet-travel-documents', '/destinations',
      ...(PAIRS[p.slug] || []).map((a) => `/airlines/${a}`),
      ...(['japan', 'canada', 'south-korea'].includes(p.slug) ? ['/airlines'] : [])];
  return [...new Set(links)].map((href) => ({ href, label: label(href) }));
};

const postProcess = (html) => html
  .replace(/<table>/g, '<div class="pack-table"><table>').replace(/<\/table>/g, '</table></div>')
  .replace(/<a href="(https?:\/\/[^"]+)"/g, '<a href="$1" target="_blank" rel="noopener nofollow"');

// Splits the article right after the "Check your crate…" section so the CTA can be inserted there.
export const packHtml = (p) => {
  const parts = p.md.split(/^(?=#{2,3} )/m);
  const i = parts.findIndex((s) => /^#{2,3} Check your crate/.test(s));
  const md = (arr) => postProcess(marked.parse(arr.join(''), { gfm: true }));
  return { top: md(parts.slice(0, i + 1)), bottom: md(parts.slice(i + 1)) };
};

export const packLd = (p) => [
  {
    '@context': 'https://schema.org', '@type': 'BreadcrumbList',
    itemListElement: [['Home', '/'], [p.kind === 'airlines' ? 'Airlines' : 'Destinations', `/${p.kind}`], [packName(p), p.route]]
      .map(([name, url], idx) => ({ '@type': 'ListItem', position: idx + 1, name, item: `https://petflycheck.io${url}` })),
  },
  {
    '@context': 'https://schema.org', '@type': 'FAQPage',
    mainEntity: p.faq.map(({ q, a }) => ({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } })),
  },
];

export { CONTENT_PACK };
